import { render } from "./FlowSwapButton.vue?vue&type=template&id=2f5e0444&scoped=true"
import script from "./FlowSwapButton.vue?vue&type=script&lang=ts"
export * from "./FlowSwapButton.vue?vue&type=script&lang=ts"

import "./FlowSwapButton.vue?vue&type=style&index=0&id=2f5e0444&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f5e0444"

export default script